import React, { useEffect, useState } from "react";
import { Formik, Form } from "formik";
import { useNavigate, useLocation } from "react-router-dom";
import * as Yup from "yup";
import LoadCSSforfirstTime from "../../../../CloudStorage/LoadCSSforfirstTime";
import CloudStorage from "../../../../CloudStorage/CloudStorage";
import {
  loginVerifyOTP,
  sendOTP,
} from "../../../../redux/zservices/BasicAPIFunctions";
import OtpInput from "react18-input-otp";
import { urtoast } from "../../../Layouts/CustomPopup/eventEmitter";
import { IS_LOGGED_IN_USER } from "../../../../assests/extention/commonfunction";

const path = "Assets/scss/FirstTimeUsers.module.scss";

const validationSchema = Yup.object().shape({
  otp: Yup.string()
    .matches(/^\d{6}$/, "OTP must be exactly 6 digits")
    .required("OTP is required"),
});

export default function FPVerifyOTPMobile({
  valuess,
  setnextPage,
  setnextPage1,
}) {
  const laung = localStorage.getItem("laung");
  const [lan, setLan] = useState(laung ?? "en");
  const [otp, setOtp] = useState("");
  const navigate = useNavigate();
  const location = useLocation();

  const [timeLeft, setTimeLeft] = useState(5);
  const [canResend, setCanResend] = useState(false);

  useEffect(() => {
    LoadCSSforfirstTime(path);
  }, []);

  useEffect(() => {
    if (!timeLeft) {
      setCanResend(true);
      return;
    }

    const intervalId = setInterval(() => {
      setTimeLeft(timeLeft - 1);
    }, 1000);

    return () => clearInterval(intervalId);
  }, [timeLeft]);

  const initialValues = {
    country_code: valuess?.country_code,
    mobile_number: valuess?.mobile_number,
    is_whatsapp: valuess?.is_whatsapp === 1 ? 1 : 0,
    otp: "",
  };

  // Extracted submission logic into a reusable function
  const submitOtpData = (otpValue) => {
    const data = {
      country_code: valuess?.country_code,
      mobile_number: valuess?.mobile_number,
      is_whatsapp: valuess?.is_whatsapp === 1 ? 1 : 0,
      otp: otpValue,
    };

    loginVerifyOTP(data)
      .then((res) => {
        if (res.data.status) {
          // const state = initialValues;
          // navigate(`/${lan}/resetpasswordwithmobile`, { state });
          setnextPage1(false);
          urtoast(res?.data?.response?.message, 1);
        } else {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      });
  };

  // Formik submit handler falls back to the helper function
  const handleSubmit = (values) => {
    submitOtpData(otp);
  };

  const resetotp = () => {
    setTimeLeft(5);
    setCanResend(false);
    const state = initialValues;
    sendOTP(state)
      .then((res) => {
        if (res.data.status) {
          urtoast(res?.data?.response?.message, 1);
        } else {
          urtoast(res?.data?.response?.message, 2);
        }
      })
      .catch((e) => {
        urtoast(e.message, 2);
      });
  };

  return (
    <div className="mx-auto register email otp-sec">
      <img
        className="mail-img"
        src={`${CloudStorage.cloudurl}/Assets/Images/common/otp.svg`}
        alt=""
      />
      <h1>Verify OTP</h1>
      <p>
        OTP has been sent to the mobile number {valuess?.country_code}
        {valuess?.mobile_number}. <span>Please verify the OTP</span>
      </p>
      {IS_LOGGED_IN_USER ? (
        <></>
      ) : (
        <p>
          <a
            onClick={() => {
              setnextPage(true);
            }}
          >
            Change Mobile Number
          </a>
        </p>
      )}
      <Formik
        initialValues={initialValues}
        validationSchema={validationSchema}
        onSubmit={handleSubmit}
      >
        {({ errors, touched, setFieldValue }) => (
          <Form>
            <div className="col-md-11 mx-auto form-sec">
              <div className="form-group">
                <label htmlFor="otp">OTP</label>
                <OtpInput
                  value={otp}
                  onChange={(newOtp) => {
                    setOtp(newOtp);
                    setFieldValue("otp", newOtp);

                    // Auto-submit when the 6th digit is entered
                    if (newOtp.length === 6) {
                      submitOtpData(newOtp);
                    }
                  }}
                  numInputs={6}
                  // separator={<span>-</span>}
                  isInputNum={true}
                  shouldAutoFocus={true}
                  containerStyle="otp-container"
                  inputStyle="otp-input"
                />
                {errors.otp && touched.otp ? (
                  <div className="error">{errors.otp}</div>
                ) : null}
              </div>

              <div className="last-form">
                <button className="btn create-account" type="submit">
                  Submit
                </button>
                <p>
                  Didn’t receive OTP?{" "}
                  <a onClick={resetotp}>
                    {" "}
                    {!canResend ? `Resend in ${timeLeft} seconds` : "Resend"}
                  </a>
                </p>
              </div>
            </div>
          </Form>
        )}
      </Formik>
    </div>
  );
}